import { Injectable } from '@angular/core';
import { Observable, of } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class PreferencesApiService {
  public getInputPreferences(): Observable<any> {
    const preferences = [
      {
        id: 'POSTGRES',
        name: 'PostgreSQL',
        description: 'Description',
        type: 'DATASOURCE',
        status: 'OPEN',
        parameters: {
          fields: [
            {
              id: 'PG_HOST',
              type: 'TEXT',
              label: 'Hostname',
              info: 'e.g., my-postgres-db.yourdomain.com',
              default_value: null,
              required: true,
              editable: false,
            },
            {
              id: 'PG_PORT',
              type: 'TEXT',
              label: 'Database Port',
              info: 'DB Port on which the database is running',
              default_value: '5432',
              required: true,
              editable: false,
            },
            {
              id: 'PG_DB',
              type: 'TEXT',
              label: 'Database',
              info: '[Optional Field] DB Name (case sensitive) to connect',
              default_value: null,
              required: false,
              editable: false,
            },
            {
              id: 'PG_USERNAME',
              type: 'TEXT',
              label: 'Username',
              info: 'Username to log into the database',
              default_value: '',
              required: true,
              editable: false,
            },
            {
              id: 'PG_PWD',
              type: 'PASSWORD',
              label: 'Password',
              info: 'Password for the username provided',
              default_value: '',
              required: true,
              editable: true,
            },
          ],
        },
      },
      {
        id: 'MYSQL',
        name: 'MySQL',
        description: 'MySQL is an open-source relational database management system.',
        type: 'DATASOURCE',
        status: 'OPEN',
        parameters: {
          fields: [
            {
              id: 'HOST',
              type: 'TEXT',
              label: 'Hostname',
              info: 'e.g., mysql-db.yourdomain.com',
              default_value: null,
              required: true,
              editable: false,
            },
            {
              id: 'PORT',
              type: 'TEXT',
              label: 'Database Port',
              info: 'DB Port on which the database is running',
              default_value: '3306',
              required: true,
              editable: false,
            },
            {
              id: 'DB',
              type: 'TEXT',
              label: 'Database',
              info: '[Optional Field] DB Name (case sensitive) to connect',
              default_value: null,
              required: false,
              editable: false,
            },
            {
              id: 'USERNAME',
              type: 'TEXT',
              label: 'Username',
              info: 'Username to log into the database',
              default_value: '',
              required: true,
              editable: false,
            },
            {
              id: 'PWD',
              type: 'PASSWORD',
              label: 'Password',
              info: 'Password for the username provided',
              default_value: '',
              required: true,
              editable: true,
            },
          ],
        },
      },
      {
        id: 'MARIADB',
        name: 'MariaDB',
        description: 'MariaDB is an open-source relational database management system.',
        type: 'DATASOURCE',
        status: 'OPEN',
        parameters: {
          fields: [
            {
              id: 'HOST',
              type: 'TEXT',
              label: 'Hostname',
              info: 'e.g., mariadb-db.yourdomain.com',
              default_value: null,
              required: true,
              editable: false,
            },
            {
              id: 'PORT',
              type: 'TEXT',
              label: 'Database Port',
              info: 'DB Port on which the database is running',
              default_value: '3306',
              required: true,
              editable: false,
            },
            {
              id: 'DB',
              type: 'TEXT',
              label: 'Database',
              info: '[Optional Field] DB Name (case sensitive) to connect',
              default_value: null,
              required: false,
              editable: false,
            },
            {
              id: 'USERNAME',
              type: 'TEXT',
              label: 'Username',
              info: 'Username to log into the database',
              default_value: '',
              required: true,
              editable: false,
            },
            {
              id: 'PWD',
              type: 'PASSWORD',
              label: 'Password',
              info: 'Password for the username provided',
              default_value: '',
              required: true,
              editable: true,
            },
          ],
        },
      },
      {
        id: 'SNOWFLAKE',
        name: 'Snowflake',
        description: 'Description',
        type: 'DATASOURCE',
        status: 'OPEN',
        parameters: {
          fields: [
            {
              id: 'SF_ACC_ID',
              type: 'TEXT',
              label: 'Account Identifier',
              info: 'Use Account Identifier from Snowflake Account Details',
              default_value: null,
              required: true,
              editable: false,
            },
            {
              id: 'SF_USER',
              type: 'TEXT',
              label: 'Username',
              info: 'Username to log into the account',
              default_value: '',
              required: true,
              editable: false,
            },
            {
              id: 'SF_PWD',
              type: 'PASSWORD',
              label: 'Password',
              info: 'Password for the username provided',
              default_value: '',
              required: true,
              editable: true,
            },
            {
              id: 'SF_ROLE',
              type: 'TEXT',
              label: 'User Role',
              info: 'Role to use for this connection',
              default_value: '',
              required: true,
              editable: false,
            },
            {
              id: 'SF_WAREHOUSE',
              type: 'TEXT',
              label: 'Warehouse Name',
              info: 'Warehouse to use for this connection',
              default_value: '',
              required: true,
              editable: true,
            },
            {
              id: 'DB',
              type: 'TEXT',
              label: 'Database',
              info: '[Optional Field] DB Name, case sensitive, to connect',
              default_value: null,
              required: false,
              editable: false,
            }
          ],
        },
      },
      {
        id: 'TRINO',
        name: 'Trino',
        description: 'Trino is a distributed SQL query engine designed to query large data sets.',
        type: 'DATASOURCE',
        status: 'OPEN',
        parameters: {
          fields: [
            {
              id: 'TRINO_HOST',
              type: 'TEXT',
              label: 'Hostname',
              info: 'e.g., trino.example.com',
              default_value: null,
              required: true,
              editable: false,
            },
            {
              id: 'TRINO_PORT',
              type: 'TEXT',
              label: 'Port',
              info: 'Port on which Trino is running',
              default_value: '443',
              required: true,
              editable: false,
            },
            {
              id: 'TRINO_DATABASE',
              type: 'TEXT',
              label: 'Database',
              info: 'Default database to use',
              default_value: '',
              required: true,
              editable: false,
            },
            {
              id: 'TRINO_SCHEMA',
              type: 'TEXT',
              label: 'Schema',
              info: '[Optional] Default schema to use',
              default_value: '',
              required: false,
              editable: false,
            },
            {
              id: 'TRINO_USERNAME',
              type: 'TEXT',
              label: 'Username',
              info: 'Username to connect to Trino',
              default_value: '',
              required: true,
              editable: false,
            },
            {
              id: 'TRINO_PWD',
              type: 'PASSWORD',
              label: 'Password',
              info: '[Optional] Password for authentication (if required)',
              default_value: '',
              required: false,
              editable: true,
            },
          ],
        },
      },
      {
        id: 'STARBURST',
        name: 'Starburst',
        description: 'Starburst is a distributed SQL query engine designed to query large data sets.',
        type: 'DATASOURCE',
        status: 'OPEN',
        parameters: {
          fields: [
            {
              id: 'STARBURST_HOST',
              type: 'TEXT',
              label: 'Hostname',
              info: 'e.g., starburst.example.com',
              default_value: null,
              required: true,
              editable: false,
            },
            {
              id: 'STARBURST_PORT',
              type: 'TEXT',
              label: 'Port',
              info: 'Port on which Starburst is running',
              default_value: '443',
              required: true,
              editable: false,
            },
            {
              id: 'STARBURST_DATABASE',
              type: 'TEXT',
              label: 'Database',
              info: 'Default database to use',
              default_value: '',
              required: true,
              editable: false,
            },
            {
              id: 'STARBURST_SCHEMA',
              type: 'TEXT',
              label: 'Schema',
              info: '[Optional] Default schema to use',
              default_value: '',
              required: false,
              editable: false,
            },
            {
              id: 'STARBURST_USERNAME',
              type: 'TEXT',
              label: 'Username',
              info: 'Username to connect to Starburst',
              default_value: '',
              required: true,
              editable: false,
            },
            {
              id: 'STARBURST_PWD',
              type: 'PASSWORD',
              label: 'Password',
              info: '[Optional] Password for authentication (if required)',
              default_value: '',
              required: false,
              editable: true,
            },
          ],
        },
      },
      {
        id: 'MCP',
        name: 'MCP Server',
        description:
          'Model Context Protocol server over HTTP/S — live tools and context for agent workflows (see product roadmap: Agents & MCP).',
        type: 'DATASOURCE',
        status: 'OPEN',
        parameters: {
          fields: [
            {
              id: 'MCP_SERVER_URL',
              type: 'TEXT',
              label: 'Server URL',
              info: 'HTTPS URL for your MCP server (streamable HTTP or documented MCP base URL)',
              default_value: '',
              required: true,
              editable: false,
            },
            {
              id: 'MCP_TRANSPORT',
              type: 'SELECT',
              label: 'Transport',
              info: 'How the client connects to the MCP server (streamable HTTP is typical for remote URLs).',
              default_value: 'streamable_http',
              required: false,
              editable: true,
              advanced: true,
              options: [
                { value: 'streamable_http', label: 'Streamable HTTP' },
                { value: 'sse', label: 'SSE (Server-Sent Events)' },
                { value: 'http', label: 'HTTP' },
              ],
            },
            {
              id: 'MCP_AUTH_TOKEN',
              type: 'PASSWORD',
              label: 'Auth password (optional)',
              info: 'Optional bearer token for validation requests (Authorization: Bearer …)',
              default_value: '',
              required: false,
              editable: true,
            },
          ],
        },
      },
      {
        id: 'FILE',
        name: 'File Upload',
        description: 'Upload data file(s)',
        type: 'DATASOURCE',
        status: 'OPEN',
        parameters: {
          fields: [
            // {
            //   id: 'KEY',
            //   type: 'TEXT',
            //   label: 'Path',
            //   info: 'Path to organize your file, like MySchema/MySubFolder',
            //   default_value: '',
            //   required: true,
            //   editable: false,
            // },
            {
              id: 'DELIMETER',
              type: 'TEXT',
              label: 'Values delimeter',
              info: 'Provide standard delimeter if its different then comma(,)',
              default_value: ',',
              required: false,
              editable: true,
            },
            {
              id: 'FILE',
              type: 'FILE',
              label: 'Chose your File',
              info: '',
              default_value: '',
              required: true,
              editable: true,
            }
          ],
        },
      }
    ];

    return of(preferences);
  }

  public getDatabases(): Observable<any[]> {
    const databases = [
      { name: 'SnowFlake', src: 'assets/img/snowflake.png', tier: 'Free Tier', status: 'Active', type: 'Data Warehouse' },
      { name: 'Postgres', src: 'assets/img/postgres.png', tier: 'Free Tier', status: 'Active', type: 'Relational' },
      { name: 'MySQL', src: 'assets/img/mysql.png', tier: 'Free Tier', status: 'Active', type: 'Relational' },
      { name: 'MariaDB', src: 'assets/img/maria-db.png', tier: 'Free Tier', status: 'Active', type: 'Relational' },
      { name: 'Trino', src: 'assets/img/trinodb.jpeg', tier: 'Free Tier', status: 'Active', type: 'Data Lakehouse' },
      { name: 'Starburst', src: 'assets/img/starburst.png', tier: 'Free Tier', status: 'Active', type: 'Data Lakehouse' },
      { name: 'File', src: 'assets/img/file-upload.png', tier: 'Free Tier', status: 'Active', type: 'File' },
      {
        name: 'MCP',
        src: 'assets/icons/mcp.svg',
        tier: 'Free Tier',
        status: 'Active',
        type: 'MCP',
      },
      { name: 'Oracle', src: 'assets/img/oracle.svg', tier: 'Coming Soon', status: 'Coming Soon', type: 'Relational' },
      { name: 'SQL Server', src: 'assets/img/sql-server.svg', tier: 'Coming Soon', status: 'Coming Soon', type: 'Relational' },
      { name: 'MongoDB', src: 'assets/img/mongodb.png', tier: 'Coming Soon', status: 'Coming Soon', type: 'NoSQL' },
      { name: 'AWS S3', src: 'assets/img/aws_s3.jpeg', tier: 'Coming Soon', status: 'Coming Soon', type: 'Cloud Storage' },
      { name: 'Microsoft Azure Blob Storage', src: 'assets/img/azure_blob.jpeg', tier: 'Coming Soon', status: 'Coming Soon', type: 'Cloud Storage' },
      { name: 'Google Cloud Storage', src: 'assets/img/google_storage.jpeg', tier: 'Coming Soon', status: 'Coming Soon', type: 'Cloud Storage' },
      { name: 'Microsoft Sharepoint', src: 'assets/img/sharepoint.jpeg', tier: 'Coming Soon', status: 'Coming Soon', type: 'File' },
      { name: 'Google Drive', src: 'assets/img/google_drive.jpeg', tier: 'Coming Soon', status: 'Coming Soon', type: 'File' },
      { name: 'Dropbox Business', src: 'assets/img/dropbox.jpeg', tier: 'Coming Soon', status: 'Coming Soon', type: 'File' },
      { name: 'DuckDB', src: 'assets/img/DuckDB.png', tier: 'Coming Soon', status: 'Coming Soon', type: 'Relational' },
      { name: 'ClickHouse', src: 'assets/img/clickhouse.svg', tier: 'Coming Soon', status: 'Coming Soon', type: 'Relational' },
      { name: 'Sample Data', src: 'assets/img/sample-data.png', tier: 'Coming Soon', status: 'Coming Soon', type: 'Sample' },
      { name: 'Cassandra', src: 'assets/img/Cassandra.svg', tier: 'Coming Soon', status: 'Coming Soon', type: 'NoSQL' },
      { name: 'Weaviate', src: 'assets/img/weaviate.png', tier: 'Coming Soon', status: 'Coming Soon', type: 'Vector' },
    ];

    return of(databases);
  }
}
